const RISK_TESTS = {
  anxiety_beck_test: {
    label: "Anxiety Beck",
    riskThreshold: 22,
  },
  depression_beck_test: {
    label: "Depression Beck",
    riskThreshold: 20,
  },
  depression_yesavage_test: {
    label: "Yesavage",
    riskThreshold: 11,
  },
};

const TEST_INTERPRETATIONS = {
  anxiety_beck_test: [
    { min: 0, max: 21, label: "Muy baja" },
    { min: 22, max: 35, label: "Moderada" },
    { min: 36, max: 63, label: "Severa" },
  ],
  depression_beck_test: [
    { min: 0, max: 13, label: "Mínima" },
    { min: 14, max: 19, label: "Leve" },
    { min: 20, max: 28, label: "Moderada" },
    { min: 29, max: 63, label: "Grave" },
  ],
  depression_yesavage_test: [
    { min: 0, max: 10, label: "Normal" },
    {
      min: 11,
      max: 14,
      label: "Depresión Sensibilidad 84% Especificidad 95%",
    },
    {
      min: 15,
      max: 30,
      label: "Depresión Sensibilidad 80% Especificidad 100%",
    },
  ],
};

export const normalizeTestName = (name) =>
  String(name || "")
    .toLowerCase()
    .replace(/\s+/g, "_");

export const getSeverityLabel = (testKey, score) => {
  const ranges = TEST_INTERPRETATIONS[testKey];
  if (!ranges || score == null || Number.isNaN(Number(score))) {
    return "Sin interpretación";
  }

  const numericScore = Number(score);
  const found = ranges.find(
    (range) => numericScore >= range.min && numericScore <= range.max
  );
  return found ? found.label : "Fuera de rango";
};

export const isHighRiskScore = (testKey, score) => {
  const config = RISK_TESTS[testKey];
  if (!config || score == null || Number.isNaN(Number(score))) return false;
  return Number(score) >= config.riskThreshold;
};

const pickMostRecentTest = (candidate, current) => {
  const candidateDate = new Date(candidate.testDay).getTime();
  const currentDate = new Date(current.testDay).getTime();

  if (candidateDate !== currentDate) {
    return candidateDate > currentDate;
  }

  const candidateScore = Number(candidate.testResultNumber);
  const currentScore = Number(current.testResultNumber);

  if (
    !Number.isNaN(candidateScore) &&
    !Number.isNaN(currentScore) &&
    candidateScore !== currentScore
  ) {
    return candidateScore > currentScore;
  }

  // Misma fecha y puntaje: conservar la última aplicación registrada.
  return true;
};

export const buildHighRiskAlerts = (patients) => {
  const alerts = [];

  for (const patient of patients) {
    const tests = patient.tests || [];
    const latestByTest = {};

    for (const test of tests) {
      const testKey = normalizeTestName(test.testName);
      if (!RISK_TESTS[testKey]) continue;

      const current = latestByTest[testKey];
      if (!current || pickMostRecentTest(test, current)) {
        latestByTest[testKey] = test;
      }
    }

    for (const [testKey, test] of Object.entries(latestByTest)) {
      const score = test.testResultNumber;
      if (!isHighRiskScore(testKey, score)) continue;

      alerts.push({
        patientId: patient.id,
        patientName: patient.name,
        testKey,
        testName: test.testName,
        testDay: test.testDay,
        score: Number(score),
        severity: test.result || getSeverityLabel(testKey, score),
      });
    }
  }

  return alerts.sort((a, b) => new Date(b.testDay) - new Date(a.testDay));
};

export const buildRiskKpis = (alerts) => ({
  total: alerts.length,
  anxietyBeck: alerts.filter((a) => a.testKey === "anxiety_beck_test").length,
  depressionBeck: alerts.filter((a) => a.testKey === "depression_beck_test")
    .length,
  yesavage: alerts.filter((a) => a.testKey === "depression_yesavage_test")
    .length,
});

export const RISK_TEST_LABELS = RISK_TESTS;
